/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import P1 from './Privacy-1.png';
import P2 from './Privacy-2.png';
import P3 from './Privacy-3.png';
import P4 from './Privacy-4.png';
import P5 from './Privacy-5.png';
import P6 from './Privacy-6.png';
import P7 from './Privacy-7.png';

export default [
    P1,
    P2,
    P3,
    P4,
    P5,
    P6,
    P7
];